module.exports = __webpack_public_path__ + "img/mobile-tree-folder.a223d7c1.svg";